<template>
  <div id="stamp" class="borda-redonda">
    <b-row>
      <b-col cols="12" class="m-0">
        <p class="m-0">
          <strong>{{ descricao }}</strong>
        </p>
      </b-col>
      <b-col cols="12">
        <b-form-select v-model="profissional" class="mt-2">
          <b-form-select-option
            v-for="profissional of getProfissionais"
            v-bind:key="profissional.id"
            :value="profissional"
            class="text-center"
            :change="carregar()"
            >{{ profissional.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col cols="12" class="p-0 text-center">
        <p>{{ profissional.descricao }}</p>
      </b-col>
    </b-row>
    <b-img
      :src="preview == null ? require('/static/images/no-stamp.png') : preview"
      class="rounded-0 inFront"
      :style="{ left: posicao }"
      fluid
    />
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import Files from "@/http/files";

export default {
  name: "StampComponent",

  props: ["descricao", "posicao"],

  data() {
    return {
      preview: null,
      profissional: this.getProfissionais[0],
      files: new Files(this.$http),
    };
  },

  methods: {
    carregar() {
      if (this.profissional.id != 0) {
        let filename = this.profissional.id + "";
        this.files
          .downloadStamp(filename)
          .then((image) => {
            const reader = new FileReader();
            const blob = new Blob([image]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.preview = e.target.result;
            };
          })
          .catch(() => (this.preview = null));
      }
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped>
.inFront {
  position: absolute;
  top: 1.5rem;
  max-width: 200px;
}

.borda-redonda {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0.5rem;
  min-height: 10.3rem;
}
</style>
